import { render, staticRenderFns } from "./CustomDropZone.vue?vue&type=template&id=1262f9ce&scoped=true&"
import script from "./CustomDropZone.vue?vue&type=script&lang=js&"
export * from "./CustomDropZone.vue?vue&type=script&lang=js&"
import style0 from "./CustomDropZone.vue?vue&type=style&index=0&id=1262f9ce&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1262f9ce",
  null
  
)

export default component.exports